
import React from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

interface SignInFormProps {
  email: string;
  password: string;
  isLoading: boolean;
  authError: string | null;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleSignIn: (e: React.FormEvent) => void;
  handlePasswordReset: () => void;
}

const SignInForm: React.FC<SignInFormProps> = ({
  email,
  password,
  isLoading,
  authError,
  handleChange,
  handleSignIn,
  handlePasswordReset,
}) => {
  return (
    <form onSubmit={handleSignIn} className="space-y-4 pt-4">
      <div className="space-y-2">
        <label htmlFor="signin-email" className="text-sm font-medium">
          Email Address
        </label>
        <Input
          id="signin-email"
          name="email"
          type="email"
          placeholder="your@email.com"
          value={email}
          onChange={handleChange}
          required
        />
      </div>
      
      <div className="space-y-2">
        <label htmlFor="signin-password" className="text-sm font-medium">
          Password
        </label>
        <Input
          id="signin-password"
          name="password"
          type="password"
          placeholder="******"
          value={password}
          onChange={handleChange}
          required
        />
      </div>
      
      {authError && (
        <div className="bg-red-50 text-red-600 p-3 rounded-md text-sm">
          {authError}
        </div>
      )}
      
      <Button
        type="submit"
        className="w-full"
        disabled={isLoading}
      >
        {isLoading ? "Signing in..." : "Sign In"}
      </Button>
      
      <div className="text-center text-sm text-gray-500">
        <button 
          type="button" 
          onClick={handlePasswordReset} 
          className="text-techne-purple hover:underline"
        >
          Forgot your password?
        </button>
      </div>
    </form>
  );
};

export default SignInForm;
